import Vue from 'vue'
import MainApp from './MainApp.vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueFlags from "@growthbunker/vueflags";
import i18n from './i18n'
import leaflet from "./plugins/leaflet";
import './assets/css/style.css';

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import "./assets/css/global.css"
import "@/plugins/moment"
import './registerServiceWorker'

// Lodash
import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

// Layout definition
import App from "./layouts/App.vue";
import Empty from "./layouts/Empty.vue";


Vue.component("app-layout", App);
Vue.component("empty-layout", Empty);

// import JsonCSV from 'vue-json-csv'
// Vue.component('downloadCsv', JsonCSV)

// import VueHtmlToPaper from 'vue-html-to-paper';
// const options = {
//   name: '_blank',
//   specs: [
//     'fullscreen=yes',
//     'titlebar=yes',
//     'scrollbars=yes',
//   ],
//   styles: [
//   "https://cdnjs.cloudflare.com/ajax/libs/vuetify/2.4.8/vuetify.css",
//   ]
// }
// Vue.use(VueHtmlToPaper, options);

// import * as VueGoogleMaps from "vue2-google-maps" // Import package
//
// Vue.use(VueGoogleMaps, {
//   load: {
//     // TODO : ask for key
//     key: "AIzaSyCD9THSqXMorKkcHyo6devRhk0UAQ574K4",
//     libraries: "places"
//   }
// });

const requireComponent = require.context(`./components/Plotly`, true, /[\w-]+\.vue$/)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
      camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  )
  Vue.component(componentName, componentConfig.default || componentConfig)
})

// -- Flags component
Vue.use(VueFlags, {
  iconPath: '/img/flags/',
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  leaflet,
  i18n,
  render: h => h(MainApp)
}).$mount("#main-app");
